//imports
import {
    ACTIVITIES_SEARCH_ACTIVITY_LOGS_REQUEST,
    ACTIVITIES_SEARCH_ACTIVITY_LOGS_RESULT,
    ACTIVITIES_GET_ACCOUNTS_REQUEST,
    ACTIVITIES_GET_ACCOUNTS_RESULT,
    ACTIVITIES_GET_TSO_ACCOUNTS_REQUEST,
    ACTIVITIES_GET_TSO_ACCOUNTS_RESULT,
    ACTIVITIES_GET_USERS_REQUEST,
    ACTIVITIES_GET_USERS_RESULT,
} from 'Redux/actionTypes';

export const activitiesSearchActivitiesLogsRequest = (filters) => ({
    type: ACTIVITIES_SEARCH_ACTIVITY_LOGS_REQUEST,
    payload: filters,
});

export const activitiesSearchActivitiesLogsResult = (data) => ({
    type: ACTIVITIES_SEARCH_ACTIVITY_LOGS_RESULT,
    payload: data,
});

export const activitiesSearchAccountsRequest = (filters) => ({
    type: ACTIVITIES_GET_ACCOUNTS_REQUEST,
    payload: filters,
});

export const activitiesSearchAccountsResult = (data) => ({
    type: ACTIVITIES_GET_ACCOUNTS_RESULT,
    payload: data,
});

export const activitiesSearchTSOAccountsRequest = (filters) => ({
    type: ACTIVITIES_GET_TSO_ACCOUNTS_REQUEST,
    payload: filters,
});

export const activitiesSearchTSOAccountsResult = (data) => ({
    type: ACTIVITIES_GET_TSO_ACCOUNTS_RESULT,
    payload: data,
});

export const activitiesSearchUsersRequest = (filters) => ({
    type: ACTIVITIES_GET_USERS_REQUEST,
    payload: filters,
});

export const activitiesSearchUsersResult = (data) => ({
    type: ACTIVITIES_GET_USERS_RESULT,
    payload: data,
});
